import { useDispatch, useSelector } from 'react-redux';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { loginUser } from '../features/user/userSlice';
export default function ProtectedRoute({ children }) {
  const { user } = useSelector((store) => store.user);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('token');
  if (token) {
    dispatch(
      loginUser({
        token: token,
      })
    );
    navigate('/');
  }
  if (!user) {
    return <Navigate to='register' />;
  }
  return children;
}
// <div className='   overflow-hidden w-[90vw]  flex justify-between items-center gap-3 flex-wrap sm:flex-nowrap  align-element-register mt-3 lg:mt-0 '>
//   <div className='flex flex-wrap items-center gap-2 '>
//     <span>جميع الحقوق محفوظة لـ تاسك اب - 2023</span>
//     <img src={footerLogo} alt='footer logo' />
//   </div>
//   <div className='flex flex-wrap gap-2'>
//     <div className='flex gap-2 items-center'>
//       <img src={address} alt='address' />
//       <span className='text-[#666] text-xs'>
//         طريق الامام سعود بن عبد العزيز (مخرج 9), الرياض
//       </span>
//     </div>
//     <div className='flex gap-2 items-center'>
//       <img src={mail} alt='address' />
//       <span className='text-[#666] text-xs'>Apps@AppsBunches.com</span>
//     </div>
//     <div className='flex gap-2 items-center'>
//       <img src={phone} alt='address' />
//       <span className='text-[#666] text-xs'>+966 532 331 339</span>
//     </div>
//   </div>
// </div>;
